import { isString, sortBy } from 'lodash'

export const sortSelectOptions = (options: { label: string }[] | string[]) =>
  sortBy(options, (o) => {
    const label = isString(o) ? o : o.label
    if (!label?.toLowerCase) return
    if (label.toLowerCase() === 'other') return 'zzzzzzz'
    if (label.toLowerCase() === 'not applicable') return 'zzzzzza'
    return label.toLowerCase()
  })